<template>
  <div>
    <q-field>
      <q-input v-model="filter" clearable @clear="select"
          float-label="Course" :placeholder="placeholder" v-if="!hide">
        <q-autocomplete
          ref="CourseAutoComplete"
          :debounce="500"
          :max-results="maxResults"
          @search="onSearch"
          @selected="select"
          clearable
        />
      </q-input>
    </q-field>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'CourseAutoComplete',
  props: {
    select: { default: () => {} }, 
    hide: { default: false }
  },
  data () {
    return {
      filter: null,
      placeholder: 'Course Search',
      maxResults: 5
    }
  },
  computed: {
    ...mapGetters('courses', [
      'autoCompleteOptions'
    ])
  },
  methods: {
    ...mapActions('courses', [
      'fetchAutoComplete'
    ]),
    onSearch (s, done) {
      this.fetchAutoComplete({ s })
      setTimeout(() => {
        done(this.autoCompleteOptions)
      }, 1000)
    }
  }
}
</script>

<style>
</style>
